import { createStyles } from 'antd-style'

import { SearchHighLightTextProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  text: {
    display: 'inline-block',
    wordBreak: 'break-all',
    [`em`]: {
      paddingInline: 0,
      color: token.volcano,
      fontStyle: 'normal'
    }
  }
}))

export const SearchHighLightText = ({
  text = '',
  className,
  // popover 传递事件
  ...restProps
}: SearchHighLightTextProps) => {
  const { cx, styles } = useStyles()

  return (
    <div
      {...restProps}
      dangerouslySetInnerHTML={{
        __html: text
      }}
      className={cx(styles.text, className)}
    />
  )
}
